import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogModel } from './confirmation-dialog.model';

@Component({
  standalone: false,
  templateUrl: 'confirmation-dialog.component.html',
  styleUrls: ['confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {
  model!: ConfirmationDialogModel;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogModel,
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>) {
    this.model = data;
  }

  get closeButtonText() {
    if (!this.model.cancelButtonText) {
      return "No, Cancel"
    }
    return this.model.cancelButtonText;
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  onAction() {
    this.dialogRef.close(true);
  }
}
